import { render } from "./AdminLandownerDetailsUpdate.vue?vue&type=template&id=28ef60cb&scoped=true&ts=true&lang=pug"
import script from "./AdminLandownerDetailsUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminLandownerDetailsUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminLandownerDetailsUpdate.vue?vue&type=style&index=0&id=28ef60cb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ef60cb"]])

export default __exports__